import { useQuery } from 'react-query';
import { getMergePreview } from '../../services/clients';

function useGetMergePreview({ clientId, sourceClientId, enabled = true }) {
  return useQuery(
    ['merge-preview', clientId, sourceClientId],
    async () => {
      return getMergePreview({
        clientId,
        sourceClientId,
        loadingStatusOff: true,
      });
    },
    {
      enabled: !!clientId && !!sourceClientId && enabled,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetMergePreview;
